import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_URL } from "../../config";

// Define the payroll API
export const payrollApi = createApi({
  reducerPath: "payrollApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getWeeklyPayroll: builder.query({
      query: (employeeId) => ({
        url: `payroll/portal/employee/${employeeId}`,
        method: 'GET',
      }),
    }),
    // Track-B Phase 2: apprentice/unsalaried-tech payroll endpoints.
    // Replaces the legacy kindredpest-communication-form /payroll-page
    // iframe. Backed by parameterized BFF queries shipped in Phase 1.
    getApprenticeWeeks: builder.query({
      query: (employeeId) => ({
        url: `payroll/portal/payroll-week/${employeeId}`,
        method: "GET",
      }),
    }),
    getApprenticePayrollWeek: builder.query({
      query: ({ employeeId, week }) => ({
        url: `payroll/portal/payroll-week/${employeeId}/${week}`,
        method: "GET",
      }),
    }),
    getApprenticeBonusDeduction: builder.query({
      query: ({ employeeId, week }) => ({
        url: `payroll/portal/bonus-deduction/${employeeId}/${week}`,
        method: "GET",
      }),
    }),
    getApprenticeReasonReservice: builder.query({
      query: ({ employeeId, week }) => ({
        url: `payroll/portal/reason-reservice/${employeeId}/${week}`,
        method: "GET",
      }),
    }),
  }),
});

// Export the auto-generated hooks
export const {
  useGetWeeklyPayrollQuery,
  useGetApprenticeWeeksQuery,
  useGetApprenticePayrollWeekQuery,
  useGetApprenticeBonusDeductionQuery,
  useGetApprenticeReasonReserviceQuery,
} = payrollApi;